module.exports = __webpack_public_path__ + "img/icon5.22c57cfc.png";